<template>
  <div class="brand-footer">
    <div class="brand-footer_wrapp">
      <div class="brand-footer_content">
        <div class="rights">
          <p class="rights_text rights_copyright">© 2021 Haymarket Media, Inc. All rights reserved.</p>
          <div class="rights_link-wrapp">
            <a class="rights_text rights_link" target="_blank" :href="this.urls.PP">Privacy Policy</a>
            <a class="rights_text rights_link" target="_blank" :href="this.urls.TC">Terms &amp; Conditions</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'BrandFooter',
  components: {},
  data() {
    return {
    };
  },
  computed: {
    ...mapState([
      'userAgent', 'urls'
    ])
  },
  methods: {},
  watch: {},
  beforeCreate: function () {
  },
  beforeMount: function () {
  },
  mounted: function () {
  },
  beforeUpdate: function () {
  },
  updated: function () {
  },
  beforeDestroy: function () {
  },
  created: function () {
  },
  destroyed: function () {
  }
};
</script>

<style lang="scss">
.brand-footer {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 50px;
  z-index: 99999;
  background-color: #ffffff;

  @include media("<tablet") {
    height: 38px;
    border-top: 1px solid #d3d3d3;
  }
  @include media("<=tablet", "landscape") {
    height: 38px;
    border-top: 1px solid #d3d3d3;
  }

  .brand-footer_wrapp {
    display: flex;
    flex-direction: row;
    margin: 0 auto;
    width: calc(100vw - 100px);
    background-color: #ffffff;
    border-top: 1px solid #d3d3d3;
    @include media("<=tablet", "landscape") {
      height: 100%;
      width: calc(100vw - 50px);
      border-top: none;
    }
    @include media("<tablet") {
      height: 100%;
      width: calc(100vw - 50px);
      border-top: none;
    }
    @include media("<phone") {
      padding: 5px 20px;
      width: 100%;
    }
    @include media("height>630px", "<phone") {
      padding-top: 0 !important;
      padding-bottom: 12.5px !important;
    }

    .screentest & {
      @include media("height>630px", "<phone") {
        padding-top: 5px !important;
        padding-bottom: 5px !important;
      }
    }
  }

  .brand-footer_content {
    margin: 0 auto;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    @include media("<phone") {
      width: 100%;
    }
  }
}

.rights_link-wrapp {
  display: flex;
  flex-direction: row;
  line-height: normal;
  @include media("<phone") {
    padding-top: 0;
  }
}

.rights {
  width: 490px;
  height: 50px;
  position: relative;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  @include media(">largeDesktop") {
    width: 100%;
  }
  @include media("<phone") {
    justify-content: center;
    flex-direction: column-reverse;
    align-items: flex-start;
    width: 100%;
    height: 100%;
  }
}

.rights_link {
  margin-right: 20px;
  position: relative;
  transition: color 0.2s;

  &:hover {
    @include media(">tablet") {
      text-decoration: none;
      color: #008EC4;
      transition: color 0.2s;
    }
  }
}

.rights_text {
  font-family: 'Open Sans', sans-serif;
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #142847;
  @include media("<phone") {
    font-size: 8px;
  }
}

.rights_copyright {
  margin-right: 20px;

  @include media("<phone") {
    padding-top: 5px;
    margin-right: 0;
  }
  @include media("height>630px", "<phone") {
    padding-top: 0;
  }

  .screentest & {
    @include media("height>630px", "<phone") {
      padding-top: 5px !important;
    }
  }
}
</style>
